(function (Drupal, once) {
  Drupal.behaviors.keidoAnalyticsClicks = {
    attach(context) {
      once("keidoAnalyticsClicks", "[data-ga-event]", context).forEach((el) => {
        el.addEventListener("click", () => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: el.dataset.gaEvent,
            button_name: el.textContent.trim(),
            button_location: el.dataset.buttonLocation,
            button_type: el.dataset.buttonType,
            page_path: window.location.pathname,
          });
        });
      });
    },
  };
})(Drupal, once);
